/* stylelint-disable no-invalid-position-at-import-rule */

import { LitElement, css } from 'lit';
import { property } from 'lit/decorators';
import { getGlobalScrollbarCss } from './utils';

export class TeComponent extends LitElement {
  static styles = [css`
    /* prettier-ignore */
    @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,500;0,700;1,400&display=swap');

    * {
      box-sizing: border-box;
      font-family: 'Roboto', sans-serif;
    }

    ${getGlobalScrollbarCss()}
  `];

  /**
   * For robot tests to identify the interactable elements
   */
  @property({ type: String }) testId = '';

  forceUpdate = (): void => this.requestUpdate();
  sendEvent = (name: string, e: Event | CustomEvent) => {
    if (e instanceof CustomEvent) {
      this.dispatchEvent(e);
    } else {
      this.dispatchEvent(new CustomEvent(name, { detail: e }));
    }
  };
  sendCustomEvent = (name: string, value: unknown) => {
    // Send custom event with custom value
    this.dispatchEvent(new CustomEvent(name, { detail: value }));
  };
  // To forward the custom event
  forwardCustomEvent = (e: CustomEvent) => {
    const newCustomEvent = new CustomEvent(e.type, { detail: e.detail });
    this.sendEvent(e.type, newCustomEvent);
  };
  handleChange = (e: Event | CustomEvent) => this.sendEvent('teChange', e);
  handleClick = (e: Event | CustomEvent) => this.sendEvent('teClick', e);
  handleToggle = (e: Event | CustomEvent) => this.sendEvent('teToggle', e);
  handleFocus = (e: Event | CustomEvent) => this.sendEvent('teFocus', e);
  handleBlur = (e: Event | CustomEvent) => this.sendEvent('teBlur', e);
  handleClose = (e: Event | CustomEvent) => this.sendEvent('teClose', e);
  handleMouseEnter = (e: Event | CustomEvent) => this.sendEvent('teHandleMouseEnter', e);
  handleMouseExit = (e: Event | CustomEvent) => this.sendEvent('teHandleMouseExit', e);
  handleKeyDown = (e: Event | CustomEvent) => this.sendEvent('teKeyDown', e);
  handleDropdownClear = (e: Event | CustomEvent) => this.sendEvent('teClear', e);
}
